module.exports = __webpack_public_path__ + "static/src/content/images/vega magic.26df7af.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/vega magic.png
// module id = 6xTR
// module chunks = 0